'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const{HandleUncaughtErrors}=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;let

BaseFleetInsightSubViewController=class BaseFleetInsightSubViewController extends BaseController{
constructor($state,$scope,groupBasedDataService,uncaughtErrorHandler,groupTreeService){
super(uncaughtErrorHandler);

this._$state=$state;
this._$scope=$scope;
this._groupBasedDataService=groupBasedDataService;

groupTreeService.linkController(this);
}

get groupTreeService(){
return this._groupTreeService;
}

set groupTreeService(groupTreeService){
this._groupTreeService=groupTreeService;
}

get $scope(){
return this._$scope;
}

get $state(){
return this._$state;
}

get stateName(){
return'fdc.features.fleetInsight';
}

get dataService(){
return this._groupBasedDataService;
}

get selectedGroupData(){
return this._groupBasedDataService.selectedGroupData;
}};


module.exports=BaseFleetInsightSubViewController;
//# sourceMappingURL=baseFleetInsightSubViewController.js.map
